import { render, staticRenderFns } from "./AppointmentActivePrice.vue?vue&type=template&id=0ebfaf73"
import script from "./AppointmentActivePrice.vue?vue&type=script&lang=js"
export * from "./AppointmentActivePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports